// import React from 'react'
// import { useSelector } from 'react-redux'
// import { Navigate, Outlet, useNavigate } from 'react-router-dom'

// const PrivateRoutes = () => {
//     const navigate = useNavigate()
//     // let loggedIn = true;
//     const loggedIn = useSelector((state)=>state.user.login)
//     console.log( loggedIn )

//     // if (loggedIn) {
//     //     return(
//     //         <Outlet/>
//     //     ) 
//     // }else{
//     //     <Navigate to={'/login'}/>
//     //     console.log('first')
//     //     // navigate('/')
//     //     console.log('scond')
//     // }
//     return (
//         loggedIn ? <Outlet/> : <Navigate to={'/login'}/>
//     )
// } 

// export default PrivateRoutes

import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

const PrivateRoutes = ({ children }) => {
    const loggedIn = useSelector((state) => state.user.login);

    // const loggedIn  = localStorage.getItem('login')
    console.log(loggedIn)
  
    // If not logged in, redirect to the login page
    if (!loggedIn) {
      return <Navigate to="/login" />;
    }
  
    // If logged in, render the children (protected routes)
    return children;
  };

export default PrivateRoutes
